var _style, _circle, _path, _circle2, _circle3, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNote5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185.61,
    height: 185.61,
    viewBox: "0 0 185.61 185.61"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#012846}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45 92.8 92.8)",
    cx: 92.8,
    cy: 92.8,
    fill: "#ef3e31",
    r: 92.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.42 153.53a3.63 3.63 0 01-1.08-7.09c.12-.04 11.84-3.71 27.88-8.82a3.63 3.63 0 012.21 6.91c-16.06 5.12-27.79 8.8-27.91 8.83-.38.12-.75.17-1.1.17z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 55.24,
    cy: 84.83,
    r: 8.79
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 130.36,
    cy: 84.83,
    r: 8.79
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.68 70.03a3.6 3.6 0 01-2.17-.73l-19.3-14.47a3.63 3.63 0 014.35-5.81l19.3 14.47a3.63 3.63 0 01-2.18 6.54zM116.93 70.03a3.63 3.63 0 01-2.18-6.53l19.3-14.47a3.63 3.63 0 114.35 5.81l-19.3 14.47c-.65.48-1.42.72-2.17.72z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxODUuNjEiIGhlaWdodD0iMTg1LjYxIiB2aWV3Qm94PSIwIDAgMTg1LjYxIDE4NS42MSI+PHN0eWxlPi5zdDF7ZmlsbDojMDEyODQ2fTwvc3R5bGU+PGNpcmNsZSB0cmFuc2Zvcm09InJvdGF0ZSgtNDUgOTIuOCA5Mi44KSIgY3g9IjkyLjgiIGN5PSI5Mi44IiBmaWxsPSIjZWYzZTMxIiByPSI5Mi44Ii8+PHBhdGggY2xhc3M9InN0MSIgZD0iTTkyLjQyIDE1My41M2EzLjYzIDMuNjMgMCAwMS0xLjA4LTcuMDljLjEyLS4wNCAxMS44NC0zLjcxIDI3Ljg4LTguODJhMy42MyAzLjYzIDAgMDEyLjIxIDYuOTFjLTE2LjA2IDUuMTItMjcuNzkgOC44LTI3LjkxIDguODMtLjM4LjEyLS43NS4xNy0xLjEuMTd6Ii8+PGNpcmNsZSBjbGFzcz0ic3QxIiBjeD0iNTUuMjQiIGN5PSI4NC44MyIgcj0iOC43OSIvPjxjaXJjbGUgY2xhc3M9InN0MSIgY3g9IjEzMC4zNiIgY3k9Ijg0LjgzIiByPSI4Ljc5Ii8+PHBhdGggY2xhc3M9InN0MSIgZD0iTTY4LjY4IDcwLjAzYTMuNiAzLjYgMCAwMS0yLjE3LS43M2wtMTkuMy0xNC40N2EzLjYzIDMuNjMgMCAwMTQuMzUtNS44MWwxOS4zIDE0LjQ3YTMuNjMgMy42MyAwIDAxLTIuMTggNi41NHpNMTE2LjkzIDcwLjAzYTMuNjMgMy42MyAwIDAxLTIuMTgtNi41M2wxOS4zLTE0LjQ3YTMuNjMgMy42MyAwIDExNC4zNSA1LjgxbC0xOS4zIDE0LjQ3Yy0uNjUuNDgtMS40Mi43Mi0yLjE3LjcyeiIvPjwvc3ZnPg==";
export { SvgNote5 as ReactComponent };